import React from 'react';
import { SvgIcon } from '@dewise-devex/backstage-plugin-mui-uikit-react';
import { styledComponent } from '@dewise-devex/backstage-plugin-mui-uikit-react';

const IconContainer = styledComponent<
  React.HTMLAttributes<HTMLDivElement> & IconContainerOwnProps
>('div', {
  ignoreProps: ['type', 'size'],
})(({ theme, ...props }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  ...(props.type === '1 - Critical' && {
    '& svg': {
      fill: theme.palette.error.error60,
      width: props.size,
      height: props.size,
    },
  }),
  ...(props.type === '2 - High' && {
    '& svg': {
      fill: theme.palette.error.error70,
      width: props.size,
      height: props.size,
    },
  }),
  ...(props.type === '3 - Medium' && {
    '& svg': {
      fill: theme.palette.error.error80,
      width: props.size,
      height: props.size,
    },
  }),
  ...(props.type === '4 - Low' && {
    '& svg': {
      fill: theme.palette.error.error90,
      width: props.size,
      height: props.size,
    },
  }),
}));

export const getWarningIcon = (
  severityCode: WorkItemSeverity,
  size?: string,
) => {
  return (
    <IconContainer type={severityCode} size={size}>
      <SvgIcon.warning />
    </IconContainer>
  );
};
